interface SpacerProps {
  height?: number | string;
}

export const Spacer = ({ height = 16 }: SpacerProps) => (
  <div style={{ height: typeof height === 'number' ? `${height}px` : height }} />
);
